__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "contractdb";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(8618), __webpack_require__.e(4613)]).then(() => (() => (__webpack_require__(64613))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(7870), __webpack_require__.e(6341)]).then(() => (() => (__webpack_require__(96341))))));
			register("@mui/material", "5.18.0", () => (Promise.all([__webpack_require__.e(4461), __webpack_require__.e(65), __webpack_require__.e(8618), __webpack_require__.e(3390), __webpack_require__.e(2743), __webpack_require__.e(3110), __webpack_require__.e(1705), __webpack_require__.e(3959), __webpack_require__.e(3553), __webpack_require__.e(7160), __webpack_require__.e(3446)]).then(() => (() => (__webpack_require__(25934))))));
			register("@reduxjs/toolkit", "1.9.7", () => (Promise.all([__webpack_require__.e(9150), __webpack_require__.e(4467)]).then(() => (() => (__webpack_require__(9150))))));
			register("axios", "1.13.6", () => (__webpack_require__.e(2340).then(() => (() => (__webpack_require__(42340))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(52407))), 1);
			register("react-redux", "8.1.3", () => (Promise.all([__webpack_require__.e(3761), __webpack_require__.e(3716)]).then(() => (() => (__webpack_require__(13761))))));
			register("react-router-dom", "6.30.3", () => (() => (__webpack_require__(44646))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(76998))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};